const Loader = (props) => {
  return (
    <div className={`row loadingParent ${props.auxiliarClass}`}>
      <div className='loadingImg'></div>
    </div>
  );
};

export default Loader;